import React, { Component, Fragment } from 'react';
import {
  StyleManager,
  Overlay,
  PickerContainer,
  StyleManagerText,
  StyledWordsContainer,
  StyledWordOption,
  StyleEditIcon,
  StyleEditOptions,
  StyledWordInput
} from './StyledComponents';

import Events from './events'

import { normaliseStyle, filterWordListByUniqueStyle, getWordsWithStyle, palette, invertPalette, isComments, isCommentsOrStrings } from './utils'

class Manager extends Component {
  state = {
    show: false,
    editing: false,
    value: null,
    word: null
  }
  componentDidMount () {  
    Events.on('closeStyleManager', this.closeStyleManager)
  }
  componentWillUnmount () {
    Events.off('closeStyleManager', this.closeStyleManager)
  }
  closeStyleManager = () => this.setState({ show: false })
  toggle = () => {
    this.setState({ show: !this.state.show }, () => {
      if (this.state.show) {
        Events.emit('closeColorPicker')
      }
    });
  }
  editStyleName = (name) => {
    this.setState({ editing: name, value: name }, () => {
      const element = document.getElementById(`style-edit-text`);
       if (element) {
        element.focus();
       }
    })
  }
  updateStyleName = (value) => {
    this.setState({ value })
  }
  saveStyleName = word => {
    const { addWord, style } = this.props
    this.setState({ editing: false, value: null })
    addWord(word, { ...style, namedStyle: true })
  }
  createWordOption = (word) => {
    const style = this.props.wordList[word];
    
        return (
          <StyledWordOption
            key={word}
            {...style}
            onClick={() => {
              this.props.setWord(word)
              this.props.setStyle(style)
            }
            }
            borderBottom={isComments(word)}
          >
            {word}
          </StyledWordOption>
        );
    }
  render() {
    const { wordList, editStyle, deleteStyle, styleEditing, style, word } = this.props;
    const show = this.state.show && !styleEditing
    const uniqueStyledWords = filterWordListByUniqueStyle(wordList)
    const words = Object.keys(uniqueStyledWords)
      .sort((a, b) => {
        const getColorIndex = color => invertPalette(palette).findIndex(hex => hex === color)
        return getColorIndex(wordList[a].c) - getColorIndex(wordList[b].c)
      })
      // .filter(key => key.trim())
      .filter(word =>  !isCommentsOrStrings(word))
      .map((key) => this.createWordOption(key));
    
    words.unshift(this.createWordOption('// comments'))
    words.unshift(this.createWordOption("'strings'"))

    let currentStyledWord = getWordsWithStyle(wordList, style)[0]
    // console.log({ word, currentStyledWord })
    if (isCommentsOrStrings(word) && JSON.stringify(normaliseStyle(wordList[word])) === JSON.stringify(normaliseStyle(style))) {
      currentStyledWord = word 
    }
    // const currentStyledWord = word || getWordsWithStyle(wordList, style)[0]
    return (
      <StyleManager ignoreOverlay={styleEditing}>
        { styleEditing && !isCommentsOrStrings(currentStyledWord) ? <StyledWordInput
              id="style-edit-text"
              {...style}
              value={this.state.value || currentStyledWord}
              onChange={e => this.updateStyleName(e.target.value)}
              onBlur={e => this.saveStyleName(this.state.value || currentStyledWord)}
            /> : <StyleManagerText {...style} content={currentStyledWord} onClick={this.toggle}>{currentStyledWord || 'unused style'}</StyleManagerText> }
        { currentStyledWord &&  <StyleEditOptions>
          <StyleEditIcon icon={'edittext.png'} onClick={() => editStyle(style)}/>
          { !isCommentsOrStrings(currentStyledWord) && 
            <StyleEditIcon icon={'hamburger-open.png'} onClick={() => { 
              this.setState({ editing: false })
              deleteStyle(style) 
            }}/> 
          }
        </StyleEditOptions> }
        {show && (
          <Fragment>
            <Overlay onClick={() => this.setState({ show: false })} />
            <PickerContainer left={0} width={210} height={300}>
              <StyledWordsContainer>{words}</StyledWordsContainer>
            </PickerContainer>
          </Fragment>
        )}
      </StyleManager>
    );
  }
}

export default Manager;
